import {Form} from 'antd';
import React, {useEffect, useState} from 'react';

import {detectAutoDetect} from '../../../../constants/Common';
import {APITypeEnum} from '../../../../services/interface/tableAPIType';
import waterAPI from '../../../../services/modules/IP/waterAPI';
import waterSourceJSON from '../../../../services/modules/JSON/waterSource';
import WaterForm from '../../../Forms/WaterForm';
import Loader from '../../../Loader/Loader';
import {IComponentProps} from '../../Common/perquisiteMaster';

const WaterBills: React.FC<IComponentProps> = ({
  record,
  caForm,
  onFinishFailed,
  onValuesChange,
  onSubmit
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const initialValues = {
    facility: record?.facility,
    year: record?.year
  };

  useEffect(() => {
    Promise.all([
      record?.referenceRecordId &&
        waterAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
      waterSourceJSON()
    ])
      .then(([res1]) => {
        if (res1?.data?.isDeleted === false) {
          caForm.setFieldsValue(res1?.data);
          onValuesChange(true);
        } else {
          const fData: any = record?.fields ?? undefined;
          const customFromData: any = {
            _id: '',
            facility: record?.facility,
            source: fData?.source,
            timeFrameData: fData?.timeFrameData ?? [],
            year: record?.year,
            status: 'ready_for_review',
            comment: '',
            dataSource: 'manual'
          };

          caForm.setFieldsValue(customFromData);
        }
      })
      .catch(() => {
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <Form
      form={caForm}
      onFinish={onSubmit}
      onFinishFailed={() => {
        onFinishFailed();
      }}
      onValuesChange={() => {
        onValuesChange(false);
      }}
      initialValues={initialValues}
      autoComplete={detectAutoDetect()}
      layout="vertical"
      className="drawerForm"
    >
      <WaterForm defaultDisplayStep={true} />
    </Form>
  );
};

export default WaterBills;
